"use strict";
exports.__esModule = true;
exports.DataProvider = void 0;
var DataProvider;
(function (DataProvider) {
    DataProvider["nscc"] = "nscc";
    DataProvider["nasd"] = "nasd";
    DataProvider["morningstar"] = "morningstar";
    DataProvider["matrix"] = "matrix";
    DataProvider["xignite"] = "xignite";
    DataProvider["sample"] = "sample";
    DataProvider["bloomberg"] = "bloomberg";
    DataProvider["manual"] = "manual";
    DataProvider["autofill"] = "autofill";
    DataProvider["internalSDBA"] = "internalSDBA";
})(DataProvider = exports.DataProvider || (exports.DataProvider = {}));
